import React, {Component} from 'react';
import PercentChart from './PercentChart';

export default class ROE extends Component {
  render() {
    return <PercentChart up title='ROE (***)' upDownPercent='11.10%' percent='24.40%' />;
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/PercentChart/ROE.js